import React from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import ScrollToTop from "common/ScrollToTop";
import store from "state/store";
import NotFoundPage from "pages/404";
import { TimerProvider } from "components/common/wrappers/withTimer";
import { PopupProvider } from "components/common/wrappers/withPopup";
import { BreakpointProvider } from "components/common/wrappers/withBreakpoint";
import { PromoProvider } from "components/common";
import Boost from "./pages/Boost/TomoBoost";
import BoostFAQ from "./pages/BoostFaq";
import BoostBlog from "./pages/BoostBlog";
import BoostCheckout from "./pages/Boost/BoostCheckout";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const AppBoost = () => {
  return (
    <Router>
      <Provider store={store}>
        <BreakpointProvider>
          <PromoProvider>
            <TimerProvider>
              <PopupProvider>
                <Helmet />
                <ScrollToTop />
                <Switch>
                  <Route
                    sensitive
                    path="/:anything*([A-Z]):anything*/"
                    render={(props) => (
                      <Redirect to={`${props.location.pathname.toLowerCase()}`} />
                    )}
                  />
                  <Route exact path={["/", "/boost"]} component={Boost} />
                  <Route exact path="/boost-pricing" component={BoostCheckout} />
                  <Route exact path="/boost-faq" component={BoostFAQ} />
                  <Route exact path="/boost-blog" component={BoostBlog} />
                  <Route exact path="/privacypolicy" component={PrivacyPolicy} />
                  <Route component={NotFoundPage} />
                </Switch>
              </PopupProvider>
            </TimerProvider>
          </PromoProvider>
        </BreakpointProvider>
      </Provider>
    </Router>
  );
};

export default AppBoost;
